import React, {} from 'react';
import { pictureFocusStyle } from './sitePicture.js';
const styles = {"rows":"StoryRows-module__rows__EPvnD","row":"StoryRows-module__row__zz9kM","figure":"StoryRows-module__figure__aEanC","picture":"StoryRows-module__picture__6DcHz","label":"StoryRows-module__label__u9IK6","story":"StoryRows-module__story__GhZpq"};
/** "What a lesson looks like": a large picture beside a short story, alternating sides on wide screens. */
export function StoryRows({ rows }) {
    return (React.createElement("div", { className: styles.rows }, rows.map((row, index) => (React.createElement("article", { key: index, className: styles.row },
        React.createElement("figure", { className: styles.figure },
            React.createElement("img", { className: styles.picture, src: row.picture.src, alt: row.picture.description, style: pictureFocusStyle(row.picture), loading: "lazy" })),
        React.createElement("div", null,
            React.createElement("p", { className: styles.label }, row.label),
            React.createElement("p", { className: styles.story }, row.story),
            row.extra))))));
}
//# sourceMappingURL=StoryRows.js.map